import { Box } from '@mui/material';
import React, { useState } from 'react';
import NavigationBar from './UserManagement/NavigationBar';
import Request from './UserManagement/Request';
import Permissions from '../Settings/UserManagement/Permissions';
import User from './UserManagement/User';
import Groups from './UserManagement/Groups';

const ManagementContainer = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  // const renderPage = () => {
  //   switch (activeTab) {
  //     case 0:
  //       return <Request searchQuery={searchQuery} />;
  //     case 1:
  //       return <Permissions />;
  //     case 2:
  //       return <User searchQuery={searchQuery} />;
  //     case 3:
  //       return <Groups />;
  //     default:
  //       return null;
  //   }
  // };

  const renderPage = () => {
    switch (activeTab) {
      case 0:
        return <Request searchQuery={searchQuery} />;
      case 1:
        return <User searchQuery={searchQuery} />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        boxSizing: 'border-box',
        height: 'auto',
        borderRadius: '12px',
        border: '1px solid #E6E6E6',
      }}
    >
      <NavigationBar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      {renderPage()}
    </Box>
  );
};

export default ManagementContainer;
